module.exports = __webpack_public_path__ + "img/success.b67d5d69.svg";